/**
 * События страниц: сколько раз открыли, что делали и сколько времени провели.
 *
 * Коды страниц и действий придумываем мы, бэк их заранее не знает и проверяет
 * только длину — пустая строка или больше 64 символов роняют весь запрос.
 */

/** Максимум, который принимает сервер для кода страницы и кода действия. */
export const CODE_MAX_LENGTH = 64

export interface PageOpenEvent {
  name: 'page_open'
  page: string
}

export interface PageActionEvent {
  name: 'page_action'
  page: string
  action: string
  /** Объект действия: id, вариант выбора. Нет объекта — поле не передаём. */
  value?: string
}

export interface PageTimeEvent {
  name: 'page_time'
  page: string
  /** Миллисекунды с прошлой отправки, а не с открытия страницы. */
  duration_ms: number
}

export type PageEvent = PageOpenEvent | PageActionEvent | PageTimeEvent
